/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
   providedIn: 'root',
})
export class BroadcastChannelService {
   private subjectFamilyChannel = new BroadcastChannel('subject-family-update');
   
   private messageSubjectFamily = new Subject<any>();

   messageSubjectFamily$ = this.messageSubjectFamily.asObservable();

   constructor() {
      this.subjectFamilyChannel.onmessage = event => {
         this.messageSubjectFamily.next(event.data);
      };
   }

   send(message: any): void {
      this.subjectFamilyChannel.postMessage(message);
   }
}
